module.exports = __webpack_public_path__ + "static/img/banner1.5434cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner1.png
// module id = dfbp
// module chunks = 1